import {
  BookmarkShapeUtil,
  DrawShapeUtil,
  EmbedShapeUtil,
  FrameShapeUtil,
  GeoShapeUtil,
  HighlightShapeUtil,
  ImageShapeUtil,
  LineShapeUtil,
  NoteShapeUtil,
  TextShapeUtil,
  VideoShapeUtil,
} from 'tldraw';

import { createSafeShapeUtil } from './createSafeShapeUtil';
import { BoardArrowShapeUtil } from './BoardArrowShapeUtil';
import { PinCardShapeUtil } from './PinCardShapeUtil';
import { SuggestPinShapeUtil } from './SuggestPinShapeUtil';
import { ConversationPinShapeUtil } from './ConversationPinShapeUtil';

/** Stock text looks up size by store id before hooks; keep a fallback after delete. */
class BoardTextShapeUtil extends TextShapeUtil {
  getMinDimensions(shape) {
    return super.getMinDimensions(shape) || { width: shape?.props?.w || 8, height: 20 };
  }
}

/** Guards stock drawing tools against delete-time render races (shape briefly undefined). */
export const DELETION_SAFE_SHAPE_UTILS = [
  createSafeShapeUtil(BoardArrowShapeUtil),
  createSafeShapeUtil(DrawShapeUtil),
  createSafeShapeUtil(LineShapeUtil),
  createSafeShapeUtil(HighlightShapeUtil),
];

// Custom + overridden defaults. Remaining stock utils merge in automatically.
export const BOARD_SHAPE_UTILS = [
  createSafeShapeUtil(PinCardShapeUtil),
  createSafeShapeUtil(SuggestPinShapeUtil),
  createSafeShapeUtil(ConversationPinShapeUtil),
  ...DELETION_SAFE_SHAPE_UTILS,
  createSafeShapeUtil(BoardTextShapeUtil),
  createSafeShapeUtil(NoteShapeUtil),
  createSafeShapeUtil(GeoShapeUtil),
  createSafeShapeUtil(BookmarkShapeUtil),
  createSafeShapeUtil(FrameShapeUtil),
  createSafeShapeUtil(EmbedShapeUtil),
  createSafeShapeUtil(ImageShapeUtil),
  createSafeShapeUtil(VideoShapeUtil),
];
